import React from 'react'
import BannerImage from '../images/bannerImage'
import FeaturesLightboxList from '../images/features-lightbox-list'
import PageTitle from '../page-title'
import SubTitle from '../sub-title'
import SEO from '../seo'
import styles from './Features.module.css'

const Features = () => {
  return (
    <div>
      <SEO title="Features" />

      <PageTitle>Features</PageTitle>

      <FeaturesLightboxList />
    </div>
  )
}

export default Features
